export const PASSENGER_IOS_LINK =
	'https://apps.apple.com/de/app/mopla/id1645774207';

export const PASSENGER_ANDROID_LINK =
	'https://play.google.com/store/apps/details?id=solutions.mopla.apps.passenger';

export const DRIVER_IOS_LINK =
	'https://apps.apple.com/de/app/fahrerapp-mobilit%C3%A4tsplattform/id1645774372';

export const DRIVER_ANDROID_LINK =
	'https://play.google.com/store/apps/details?id=solutions.mopla.apps.driver.public';
